// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let AlertType = {
    ASK: 0,
    BID: 1,
    LAST: 2,
    CHANGE: 3,
    VOLUME: 4

    //CERFFFFFFFFFFF
    // DEFAULT: 10
}
export let AlertTypeMap = {
    0: "Ask",
    1: "Bid",
    2: "Last",
    3: "ChangePr",
    4: "Volume"
}